'use client';

import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';

/** Renders only when approved testimonials exist in copy (future). */
export function SocialProofSection() {
  const c = useCadrinoCopy();
  const testimonials = "testimonials" in c && Array.isArray((c as {
    testimonials?: unknown[];
  }).testimonials) ? (c as {
    testimonials: {
      quote: string;
      role: string;
    }[];
  }).testimonials : [];
  if (testimonials.length === 0) {
    return null;
  }
  return null;
}